import { Operation } from '../../../__generated__/globalTypes'

import {
  AwardFragment,
  awardFragmentString,
} from '../../fragments/__generated__/AwardFragment'

import getAwardsRawString from '../GetAwards.graphql'

const getAwardsString = [getAwardsRawString, awardFragmentString].join('\n\n')

export type GetAwardsData = {
  awards: AwardFragment[]
}

export type GetAwards = Operation<GetAwardsData>

export const GetAwards = (): GetAwards => ({
  query: getAwardsString,
  variables: undefined,
})
